import * as React from 'react'

type Props = React.ComponentProps<'div'>

export const Badge = ({ children, className = '', ...props }: Props) => (
  <div className={['badge', className].join(' ')} {...props}>
    {children}
  </div>
)
